export default __webpack_public_path__ + "static/media/canary_spot_art.711ac226.jpeg";